import React, { useState, useRef, useEffect } from 'react';
import Icon from './Icon';
import './CategoryFilter.css';

const CategoryFilter = ({ categories = [], selectedCategories = [], onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleCategoryToggle = (categoryName) => {
    const isSelected = selectedCategories.includes(categoryName);
    const newSelection = isSelected
      ? selectedCategories.filter(c => c !== categoryName)
      : [...selectedCategories, categoryName];
    onChange(newSelection);
  };

  const handleSelectAll = () => {
    if (selectedCategories.length === categories.length) {
      onChange([]);
    } else {
      onChange(categories.map(c => c.categoryName));
    }
  };

  const handleClearAll = () => {
    onChange([]);
  };

  const isAllSelected = selectedCategories.length === categories.length;
  const displayText = selectedCategories.length === 0 
    ? 'Toutes les catégories'
    : selectedCategories.length === categories.length
    ? `Toutes (${categories.length})`
    : `${selectedCategories.length} sélectionnée${selectedCategories.length > 1 ? 's' : ''}`;

  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div className="category-filter" ref={dropdownRef}>
      <button 
        className={`category-filter-trigger ${selectedCategories.length > 0 && selectedCategories.length < categories.length ? 'has-selection' : ''}`}
        onClick={handleToggle}
        type="button"
      >
        <Icon name="Filter" size={16} />
        <span className="filter-text">{displayText}</span>
        <Icon name={isOpen ? "ChevronUp" : "ChevronDown"} size={14} />
      </button>

      {isOpen && (
        <div className="category-filter-dropdown">
          <div className="category-filter-header">
            <button 
              className="filter-action-btn"
              onClick={handleSelectAll}
              type="button"
            >
              <Icon name={isAllSelected ? "CheckSquare" : "Square"} size={16} />
              {isAllSelected ? 'Désélectionner tout' : 'Sélectionner tout'}
            </button>
            {selectedCategories.length > 0 && selectedCategories.length < categories.length && (
              <button 
                className="filter-action-btn secondary"
                onClick={handleClearAll}
                type="button"
              >
                <Icon name="X" size={16} />
                Effacer
              </button>
            )}
          </div>

          <div className="category-filter-list">
            {categories.map((category) => {
              const isSelected = selectedCategories.includes(category.categoryName);
              return (
                <label 
                  key={category.categoryName} 
                  className={`category-filter-item ${isSelected ? 'selected' : ''}`}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => handleCategoryToggle(category.categoryName)}
                  />
                  <Icon name={isSelected ? "CheckSquare" : "Square"} size={16} />
                  <span className="category-name">{category.categoryName}</span>
                  <span className="category-count">{category.keywordCount}</span>
                </label>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryFilter;
